import { url_base } from '../../config/url';
import axios from 'axios';

export async function getEventIntrusionDetailsByBuildingId(buildingId, params = {}) {
    const query = {
        buildingId,
        ...params,
    };

    const result = await axios({
        method: 'get',
        url: `${url_base}/api/bluebuilding/events/event-intrusion`,
        headers: {
            Authorization: `JWT ${localStorage.getItem('authToken')}`,
            'Content-Type': 'application/json',
        },
        params: query,
    });

    return result?.data;
}

export async function getEventOpenDoorDetailsByBuildingId(buildingId, params = {}) {
    const query = {
        buildingId,
        ...params,
    };

    const result = await axios({
        method: 'get',
        url: `${url_base}/api/bluebuilding/events/open-door`,
        headers: {
            Authorization: `JWT ${localStorage.getItem('authToken')}`,
            'Content-Type': 'application/json',
        },
        params: query,
    });

    return result?.data;
}

export async function getRecentCriticalEvents() {

    const result = await axios({
        method: 'get',
        url: `${url_base}/api/bluebuilding/events/critical/recent`,
        headers: {
            Authorization: `JWT ${localStorage.getItem('authToken')}`,
            'Content-Type': 'application/json',
        },
    });

    return result?.data;
}


